import React from 'react';
import './Stats.css';

const Stats = () => {
  return (
    <section className="stats-banner-unique">
      <div className="stats-grid-unique">
        <div className="stat-card-unique">
          <h3>50+</h3>
          <p>Anos de História</p>
        </div>
        <div className="stat-card-unique">
          <h3>600+</h3>
          <p>Atletas Ativos</p>
        </div>
        <div className="stat-card-unique">
          <h3>8</h3>
          <p>Modalidades</p>
        </div>
      </div>
    </section>
  );
};

export default Stats;
